export const Checkbox = {
  baseStyle: {
    control: {
      _checked: {
        bg: 'accentPrimary',
        border: 'none',
        _hover: {
          bg: 'primary',
          borderColor: 'primary',
        },
      },
      _focus: {
        outline: 'none',
        boxShadow: 'none',
      },
    },
  },
}
